import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PermissionCheckDirective } from './directives/permission-check.directive'
import { RightActionsEditorComponent } from './components/right-actions-editor/right-actions-editor.component'
import { FormsModule } from '@angular/forms'
import { NgxPermissionsModule } from 'ngx-permissions'
import { TreeModule } from 'primeng/tree'
import { TreeTableModule } from 'primeng/treetable'
import { CheckboxModule } from 'primeng/checkbox'

import { CardModule } from 'primeng/card'
import { ListboxModule } from 'primeng/listbox'
import { TooltipModule } from 'primeng/tooltip'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { FieldsetModule } from 'primeng/fieldset'
import { ButtonModule } from 'primeng/button'
import { PanelModule } from 'primeng/panel'
import { FillViewportDirective } from './directives/fill-viewport.directive'
import { SharedComponentsModule } from '../shared-components-module/shared.components.module'

@NgModule({
  declarations: [PermissionCheckDirective, RightActionsEditorComponent, FillViewportDirective],
  imports: [
    CommonModule,
    TreeModule,
    CardModule,
    ListboxModule,
    FormsModule,
    TooltipModule,
    ScrollPanelModule,
    FieldsetModule,
    ButtonModule,
    PanelModule,
    TreeModule,
    TreeTableModule,
    CheckboxModule,
    NgxPermissionsModule.forChild({
      permissionsIsolate: false,
      rolesIsolate: false
    }),
    SharedComponentsModule
  ],
  exports: [PermissionCheckDirective, RightActionsEditorComponent]
})
export class PermissionsModule {}
